// src/components/Loader/Loader.tsx
import React from "react";
import "../../Loader/PaymentLoader/Loader.scss";
import CircularProgress from "@mui/material/CircularProgress"; // Using Material-UI Circular Progress

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <CircularProgress size={50} />
      <p>Redirecting you to PayPal's site</p>
    </div>
  );
};

export default Loader;
